import { actionChannel, delay, fork, take } from 'redux-saga/effects'
import { buffers } from 'redux-saga'

// similar to throttle but don't hold a buffer.
// useful for scenarios like Explore page where, on load, 5 impression events
// each willing to call setGlobalContext if it's not ready--so we limit the
// number of times an action can run in a given time window to once
/**
 *
 * @param ms {number} - window of time to alter events
 * @param pattern {[Action]}
 * @param task {function} - Saga generator function to run
 * @param args
 * @returns {ForkEffect}
 */
export function burst(ms, pattern, task, ...args) {
  return fork(function* () {
    const throttleChannel = yield actionChannel(pattern, buffers.none())

    while (true) {
      const action = yield take(throttleChannel)
      yield fork(task, ...args, action)
      yield delay(ms)
    }
  })
}
